/**
 * Popup Form CTA functionality.
 *
 * @package ppd
 * @since   1.0.0
 */

/**
 * Import dependencies.
 */
import $ from 'jquery';

function initMainMenuPopup() {
	const mMMButtonSelector = `.main-menu-modal-trigger`;
	const mMMButtons = document.querySelectorAll(mMMButtonSelector);
	const mMMCloserSelectors = `.main-menu-modal__close, .main-menu-modal__overlay`;


	$(mMMButtons).each(
		function() {
		$(this).on('click', function () {
			$(`.main-menu-modal__popup`).toggleClass('visible');
			$('html, body').toggleClass('noscroll');
		});
		}
	);

	$(mMMCloserSelectors).each(
		function() {
			$(this).on('click', function() {
				$(`.main-menu-modal__popup`).toggleClass('visible');
				$('html, body').toggleClass('noscroll');
			});
		}
	);
}

// To prevent errors on other pages, only run this script on the insights hub page.
if (document.querySelector(".main-menu-modal")) {
	document.addEventListener('DOMContentLoaded', initMainMenuPopup);
}
